import React from 'react';
const LOGO_IMAGE = 'https://cdn.magicpatterns.com/uploads/xg4UV6L8qLtKmTNvCeFCux/ChatGPT_Image_Aug_16,_2026,_12_47_58_AM.png';

/**
 * „tavo būsena" logotipas.
 * Logotipo failas yra tamsiai mėlynas ant balto fono, todėl:
 * - ant šviesaus fono naudojame multiply (baltas fonas išnyksta),
 * - ant tamsaus fono invertuojame ir naudojame screen (fonas išnyksta, raštas pašviesėja).
 */
export function Logo({
  tone = 'dark',
  className = 'h-9'
}: {
  tone?: 'dark' | 'light';
  className?: string;
}) {
  return <img src={LOGO_IMAGE} alt="tavo būsena" className={`${className} w-auto select-none`} style={tone === 'light' ? {
    filter: 'invert(1) brightness(1.35)',
    mixBlendMode: 'screen'
  } : {
    mixBlendMode: 'multiply'
  }} data-id="element-68" data-mp="rqwa6tnye4qv" />;
}